import { Radio } from 'semantic-ui-react';
import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { useUpdateUserPermissions } from 'services/user/update-permissions';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import { useUserPermissions } from 'services/user/permissions';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export function ManageSystemAdminPermissions() {
 
  const intl = useIntl();
  const { selectedUser } = useContext(UserAdministrationModalContext);
  const updateUserPermissions = useUpdateUserPermissions(selectedUser);
  const { checkPermission } = useUserPermissions();
  const hasCurrentUserSystemAdminAccess = checkPermission('system-admin', 'update', 'read', 'create', 'delete', 'assign');
  const { checkPermissionsByEmail, isLoading: isLoadingForCheckPermission } = useUserPermissionsByEmail(selectedUser.email);
  const hasSystemAdminAccess = checkPermissionsByEmail('system-admin', 'update', 'read', 'create', 'delete', 'assign');
  const [hasUserSystemAdminAccess, setHasUserSystemAdminAccess] = React.useState(false);
  const { openModal } = useModal();

  useEffect(() => {
    setHasUserSystemAdminAccess(hasSystemAdminAccess);
  }, [hasSystemAdminAccess]);

  return hasCurrentUserSystemAdminAccess ? (
   
    <div className={styles.adminAccess}>
       
      <Radio
        label={intl.formatMessage({ id: 'assignAsSystemAdmin' })}
        toggle
        name="setUserAsSystemAdmin"
        checked={Boolean(hasUserSystemAdminAccess)}
        disabled={updateUserPermissions.isLoading || isLoadingForCheckPermission}
        onChange={async (event, value) => {
          setHasUserSystemAdminAccess(value.checked);
          openModal({
            modalType: 'ConfirmationModal',
            modalProps: {
              title: intl.formatMessage({ id: 'updateAdminPermissionForUser' }),
              content: intl.formatMessage({ id: 'updateAdminPermissionForUserContent' }),
              onConfirm: () => {
                updateUserPermissions.mutate({
                  userEmail: selectedUser.email,
                  permissions: {
                    'system-admin': {
                      update: value.checked,
                      create: value.checked,
                      read: value.checked,
                      delete: value.checked,
                      assign: value.checked,
                    },
                  },
                });
              },
              onCancel: () => {
                setHasUserSystemAdminAccess(hasSystemAdminAccess);
              },
            },
          });
        }}
      />
   
    </div>
  
  ) : null;
}
